import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timelineInnerRowDynamicHeight',
  standalone: true,
})
export class TimelineInnerRowDynamicHeightPipe implements PipeTransform {
  transform({
    numberOfInnerRows,
    defaultRowHeight,
    currentInnerRowIndex,
  }: {
    numberOfInnerRows: number | null;
    defaultRowHeight: number;
    currentInnerRowIndex: number;
  }): number {
    if (!numberOfInnerRows || !defaultRowHeight || numberOfInnerRows < 1) {
      return defaultRowHeight;
    } else if (numberOfInnerRows === 2) {
      if (currentInnerRowIndex === 0) return defaultRowHeight * 0.7;
      if (currentInnerRowIndex === 1) return defaultRowHeight * 0.3;
    }

    return defaultRowHeight / numberOfInnerRows;
  }
}
